import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { STUDENT_CR_SCORES } from "../../student/performance/PerformanceReport";
import { formatNumber, formatNumberOneDecimal } from "../../shared/reportUtil";
import { studentPerformanceLink } from "./PerformanceReport";
import { WriterCrTraitScore, CrTraitScore } from "./ScoresFilteredByCourseViewModel";

export function CrTraitScoreTable(props: {
	className: string;
	courseId: number;
	writerData: WriterCrTraitScore[];
	classData: CrTraitScore;
}) {
	const hasData = props.writerData && props.writerData.length > 0;

	const studentNameTemplate = (rowData: WriterCrTraitScore) => {
		return (
			<Link
				className="link"
				to={studentPerformanceLink(props.courseId, rowData.writerId)}
				state={{ section: STUDENT_CR_SCORES }}>
				{rowData.writerName}
			</Link>
		);
	};

	const textualEvidenceTemplate = (rowData: WriterCrTraitScore) => {
		return formatNumber(rowData.textualEvidenceScore);
	};

	const contentAccuracyTemplate = (rowData: WriterCrTraitScore) => {
		return formatNumber(rowData.contentAccuracyScore);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Class" footerClassName="font-medium !text-right" />
				<Column
					footer={formatNumberOneDecimal(props.classData.totalScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.textualEvidenceScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.contentAccuracyScore)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.writerData}
			dataKey="writerId"
			loading={props.writerData == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header="Student"
				body={studentNameTemplate}
				sortable
				sortField="writerName"></Column>
			<Column header="Holistic/Total" field="totalScore" sortable></Column>
			<Column
				header="Textual Evidence"
				body={textualEvidenceTemplate}
				sortable
				sortField="textualEvidenceScore"></Column>
			<Column
				header="Content Accuracy"
				body={contentAccuracyTemplate}
				sortable
				sortField="contentAccuracyScore"></Column>
		</DataTable>
	);
}
